
const routes = [
  {
    path: "/general-availability-page",
    name: "GeneralAvailabilityPage",
    component: () => import(/* webpackChunkName: "GeneralAvailabilityPage" */ "./views/GeneralAvailabilityPage")
  },
  {
    path: "/availability-exception-page-iframe",
    name: "AvailabilityExceptionPage",
    component: () => import(/* webpackChunkName: "AvailabilityExceptionPage" */ "./views/AvailabilityExceptionListPageWrapper")
  },
  {
    path: "/availability-exception-page",
    name: "AvailabilityExceptionPage",
    component: () => import(/* webpackChunkName: "AvailabilityExceptionPage" */ "./views/AvailabilityExceptionPage")
  },
  {
    path: "/single-availability-exception-edit-page",
    name: "SingleAvailabilityExceptionEditPage",
    component: () => import(/* webpackChunkName: "GeneralAvailabilityPage" */ "./views/SingleAvailabilityExcepetionEditPageWrapper")
  }
];


export default routes;
